export default __webpack_public_path__ + "static/media/landing2.9711df8e.jpeg";